module.exports = __webpack_public_path__ + "static/search-0ba6be44d7eb39c3882a859c66a50a75.png";